<template>
  <div :class="_class">
    <slot
      name="icon_finish"
      v-if="_icon === 'finish'"
    >
      <div :class="[iconName, iconName + '--finish']">
        <ten-icon icon="tick" />
      </div>
    </slot>
    <slot
      name="icon_error"
      v-else-if="_icon === 'error'"
    >
      <div :class="[iconName, iconName + '--error']">
        <ten-icon icon="error" />
      </div>
    </slot>
    <slot
      name="icon_process"
      v-else-if="_icon === 'process'"
    >
      <div :class="[iconName, iconName + '--process']">
        <template>{{ index }}</template>
      </div>
    </slot>
    <slot
      name="icon_wait"
      v-else
    >
      <div :class="[iconName, iconName + '--wait']">
        <template>{{ index }}</template>
      </div>
    </slot>

    <div class="ten-steps__content">
      <div
        v-if="_showTail"
        :class="_tail"
      />
      <div :class="_title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <div :class="_description">
        <slot name="desc">
          {{ desc }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import TenIcon from '../icon';
const name = 'ten-steps__item';
const iconName = 'ten-steps__icon';
const tail = 'ten-steps__tail';
const title = 'ten-steps__title';
const description = 'ten-steps__description';

export default {
  name: 'TenStep',
  components: { TenIcon },
  props: {
    title: String,
    desc: String,
    skip: Boolean,
  },
  data() {
    return {
      iconName,
      index: -1,
      total: 1,
      skipType: 0,
      icon: {
        finish: '',
        error: '',
      },
    };
  },
  inject: ['steps'],
  computed: {
    _class() {
      const { status, next, direction } = this.statusObj();
      return [
        name,
        `${name}--${status}`,
        next === '' ? '' : `${name}--next--${next}`,
        direction ? `${name}--${direction}` : '',
        // eslint-disable-next-line
        direction
          ? next === ''
            ? ''
            : `${name}--${direction}--next--${next}`
          : '',
      ];
    },
    _iconClass() {
      const { status } = this.statusObj();
      return [iconName, `${iconName}--${status}`];
    },
    _tail() {
      const { next, direction } = this.statusObj();
      return [
        `${tail}--${direction}`,
        next === '' ? '' : `${tail}--next--${next}`,
      ];
    },
    _title() {
      const { status, next, direction } = this.statusObj();
      return [
        title,
        `${title}--${status}`,
        next === '' ? '' : `${title}--next--${next}`,
        direction ? `${title}--${direction}` : '',
      ];
    },
    _description() {
      const { status } = this.statusObj();
      return [description, `${description}--${status}`];
    },
    _icon() {
      const { status } = this.statusObj();
      return status;
    },
    _showTail() {
      if (this.steps.direction === 'vertical') {
        return true;
      }
      return false;
    },
  },
  methods: {
    getStatus(active, index, total, direction, type, skip) {
      let status; let next;
      const _type = type && type !== '' ? type : 'process';
      if (active === index) {
        status = type && type !== '' ? type : 'process';
        next = 'wait';
      } else if (index > active) {
        status = 'wait';
        next = index === total ? '' : 'wait';
      } else if (index < active) {
        status = 'finish';
        next = index === active - 1 ? _type : 'finish';
      }
      if (skip !== 0) {
        status = skip === 2 || skip === 3 ? 'skip' : status;
        next = skip === 1 || skip === 2 ? 'skip' : next;
      }
      if (direction === 'vertical') {
        return {
          status,
          next,
          direction,
        };
      }
      return {
        status,
        next,
      };
    },
    statusObj() {
      return this.getStatus(
        this.steps.active,
        this.index,
        this.total,
        this.steps.direction,
        this.steps.status,
        this.skipType
      );
    },
  },
};
</script>
